/**
 * @class
 * @description Bitmovin loader class. It receives bitmovin instance to listen,
 * intercept and modify the requests if needed.
 * @exports LoaderDash
 */
export default class LoaderBitmovin {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    sendHttpRequest(type, request) {
        if (type === 'manifest/hls/master' || (type === 'manifest/dash' && request.url.indexOf('.mpd') > 0)) {
            LoaderBitmovin._engine.setManifestResource(request.url);
        }
        return {
            getResponse() {
                return new Promise((resolve) => {
                    LoaderBitmovin._engine.request(new URL(request.url), true, [
                        (e) => {
                            const resp = {
                                request: request,
                                url: request.url,
                                headers: e.headers,
                                status: 200,
                                statusText: 'OK',
                                body: e.data
                            };
                            resolve(resp);
                        }
                    ], request.headers, undefined, request.responseType === 'arrayBuffer');
                });
            },
            cancel() { },
            setProgressListener() { }
        };
    }
}
